import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "intervalInputModal.title",
    },
    description: {
        id: "intervalInputModal.description",
    },
    close: {
        id: "general.close",
    },
    noMore: {
        id: "intervalInputModa.noMore",
    },
});

export default messages;
